.note-head {
  $root: &;

  align-items: center;
  color: var(--palette-foreground-primary);
  display: flex;
  font: use-font("700 14px/16px");
  gap: 6px;
  position: relative;

  &::before {
    background-color: var(--palette-foreground-primary);
    border-radius: 50%;
    content: '';
    height: 6px;
    left: -18.5px;
    position: absolute;
    top: 4px;
    width: 6px;
  }

  &[data-urgent='true'] {
    color: var(--palette-accent-urgent);

    &::before {
      background-color: var(--palette-accent-urgent);
    }
  }

  &__content {
    &:empty {
      display: none;
    }
  }

  &__urgent-label {
    background-color: var(--palette-accent-urgent);
    color:  var(--palette-accent-urgent-contra);
    font: use-font-secondary("700 12px/1");
    padding: 2px 4px;
    text-transform: uppercase;
    transform: translateY(-1px); // Optical alignment with text
  }

  &__icon {
    aspect-ratio: 1 / 1;
    display: block;
    height: 16px;
    width: 16px;
  }
}
